import store from '@core/store/store';
import i18n from '@/i18n'

// 세션 만료 후 로그인 화면(/)으로 보낼 주소. 로그인 후 원래 위치로 돌아오도록 redirect 를 붙인다.
export function loginUrlWithRedirect() {
    const here = window.location.pathname + window.location.search + window.location.hash;
    return window.location.pathname === '/' ? '/' : `/?redirect=${encodeURIComponent(here)}`;
}

async function commonLogout(is_alert_duplicate_login) {
    if (typeof is_alert_duplicate_login === 'undefined' || is_alert_duplicate_login === null) {
        is_alert_duplicate_login = localStorage.getItem('is_alert_duplicate_login');
    }

    if (!is_alert_duplicate_login) {
        alert(i18n.t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
        localStorage.setItem('is_alert_duplicate_login', 1);

        await store.dispatch('logout');
        window.location.replace(loginUrlWithRedirect());
    }
}

export default commonLogout;